"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.simpleMovingAverageArray = void 0;

var _binaryUtils = require("binary-utils");

var _math = require("./math");

var simpleMovingAverage = function simpleMovingAverage(data, config) {
  var periods = config.periods,
      field = config.field;

  if (data.length < periods) {
    throw new Error('Periods longer than data length');
  }

  var vals = (0, _math.takeLast)(data, periods, field);
  return (0, _math.sum)(vals) / periods;
};

var simpleMovingAverageArray = function simpleMovingAverageArray(data, config) {
  var periods = config.periods,
      _config$pipSize = config.pipSize,
      pipSize = _config$pipSize === void 0 ? 2 : _config$pipSize;
  return (0, _binaryUtils.sequence)(data.length - periods + 1).map(function (x, i) {
    return +simpleMovingAverage(data.slice(i, i + periods), config).toFixed(pipSize);
  });
};

exports.simpleMovingAverageArray = simpleMovingAverageArray;
var _default = simpleMovingAverage;
exports["default"] = _default;